import styled from 'styled-components'

export const NewQuoteBox = styled('div')`
  border: 1px solid ${props => props.theme.palette.gray[85]};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  grid-area: new-quote-box;
  padding: 20px;
`

export const OberverBox = styled('div')`
  background-color: ${props => props.theme.palette.yellow[95]};
  border: 1px solid ${props => props.theme.palette.gray[85]};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  grid-area: new-quote-box;
  padding: 20px;
`

export const AccessToNewQuote = styled('a')`
  font-size: 13px;
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-weight: 500;
  margin-top: 12px;
`
